import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants';
import BrandMark from '../common/BrandMark';
import LegalSectionRenderer from './LegalSectionRenderer';
import { LEGAL_CONTENT } from './legalContent';
import './LegalPage.css';

const PAGE_KEYS = {
  [ROUTES.TERMS]: 'terms',
  [ROUTES.PRIVACY]: 'privacy',
  [ROUTES.GUIDELINES]: 'guidelines',
};

function LegalPage() {
  const { pathname } = useLocation();
  const page = LEGAL_CONTENT[PAGE_KEYS[pathname]];

  if (!page) return null;

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to={ROUTES.AUTH} className="legal-nav__logo">
          <BrandMark className="legal-nav__brand-mark" compact />
        </Link>
        <div className="legal-nav__links">
          <Link to={ROUTES.TERMS} className={`legal-nav__link${pathname === ROUTES.TERMS ? ' legal-nav__link--active' : ''}`}>Terms</Link>
          <Link to={ROUTES.PRIVACY} className={`legal-nav__link${pathname === ROUTES.PRIVACY ? ' legal-nav__link--active' : ''}`}>Privacy</Link>
          <Link to={ROUTES.GUIDELINES} className={`legal-nav__link${pathname === ROUTES.GUIDELINES ? ' legal-nav__link--active' : ''}`}>Guidelines</Link>
        </div>
      </nav>

      <main className="legal-page__main">
        <div className="legal-page__container">
          <h1 className={`legal-page__title${page.lastUpdated ? '' : ' legal-page__title--standalone'}`}>{page.label}</h1>
          {page.lastUpdated && (
            <p className="legal-page__updated">Last Updated: {page.lastUpdated}</p>
          )}

          <div className="legal-page__body">
            <LegalSectionRenderer
              sections={page.sections}
              classNamePrefix="legal-page"
              sectionHeadingTag="h2"
            />
          </div>

          <div className="legal-page__back">
            <Link to={ROUTES.AUTH} className="legal-page__back-btn">← Back to Sign In</Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default LegalPage;
